import { render, staticRenderFns } from "./DialogConfermaOrdine.vue?vue&type=template&id=5c74f745&"
import script from "./DialogConfermaOrdine.vue?vue&type=script&lang=js&"
export * from "./DialogConfermaOrdine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports